import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { ConnectionProvider } from "@common/types/integrationConnection";
import { integrationConnectionWithAccountsResponseSchema } from "@common/schemas/domains/integrationConnection/integration-connection-response.schema";
import { ErrorMessageSchema } from "@common/schemas/error.schema";

export enum IntegrationConnectionErrorCode {
    ACCOUNTING_MIGRATION_EXISTS = "accounting_migration_exists",
    ACCOUNTING_MIGRATION_LOCKED = "accounting_migration_locked",
}

const c = initContract();

export const integrationConnectionContract = c.router(
    {
        getConnections: {
            method: "GET",
            path: "/:workspaceId",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
            }),
            query: z.object({
                provider: z.nativeEnum(ConnectionProvider).optional(),
            }),
            responses: {
                200: z.object({
                    connections: z.array(
                        integrationConnectionWithAccountsResponseSchema,
                    ),
                }),
            },
        },
        getConnection: {
            method: "GET",
            path: "/:workspaceId/:connectionId",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
                connectionId: z.string().uuid(),
            }),
            responses: {
                200: z.object({
                    connection: integrationConnectionWithAccountsResponseSchema,
                }),
                404: c.noBody(),
            },
        },
        fixConnection: {
            method: "PATCH",
            path: "/:workspaceId/:connectionId/fix",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
                connectionId: z.string().uuid(),
            }),
            body: z.object({
                oAuthCode: z.string().optional(),
                customParams: z.any().optional(),
            }),
            responses: {
                204: c.noBody(),
                400: c.type<{ message: string }>(),
            },
        },
        removeConnection: {
            method: "DELETE",
            path: "/:workspaceId/:connectionId",
            pathParams: z.object({
                workspaceId: z.string().uuid(),
                connectionId: z.string().uuid(),
            }),
            body: z.object({
                removeAccountingMigration: z.boolean().optional(),
            }),
            responses: {
                204: c.noBody(),
                403: ErrorMessageSchema,
                404: c.noBody(),
                409: c.type<{
                    message: string;
                    errorCode: IntegrationConnectionErrorCode;
                }>(),
            },
        },
    },
    {
        pathPrefix: "/integration-connection",
    },
);
